var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-333 -22) translate(333 22)"},React.createElement("g",null,React.createElement("path",{"fillRule":"nonzero","d":"M7 0c3.866 0 7 3.134 7 7 0 1.572-.518 3.024-1.394 4.192l5.586 5.586-1.414 1.414-5.586-5.586C10.024 13.482 8.572 14 7 14c-3.866 0-7-3.134-7-7s3.134-7 7-7zm0 2C4.239 2 2 4.239 2 7s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5z","transform":"translate(3 3)"}))))));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
